<template>
    <div>
    <div v-if="isLoading" class="loading">Loading&#8230;</div> 
    <vue-snotify/>


<div id="myModalRetards" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" style="width:80%; height:85%;">
    <div  class="box has-background-grey">
        <CompRetards 
        :group_id="data_contact"
        :student_cnt="data_contact.length"
        @close_modal_retards="close_modal_retards"
        >   </CompRetards>
    </div>
  </div>
</div>



<div id="myModalContact" class="modal">
  <div class="modal-background"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box has-background-grey">
        <Contact 
        :data_students="data_contact"
        :student_cnt="data_contact.length"
        @emit_close_modal="close_contact_modal"
        >   </Contact>
    </div>
  </div>
</div>



<div id="myModalSchedule" class="modal">
  <div class="modal-background" @click="close_schedule_modal()"></div>
  <div class="modal-content" style="width:60%; height:85%;">
    <div  class="box">




<div class="columns is-gapless">

<div class="column is-6 is-uppercase underIT is-size-3">Planifier un cours</div>

<div class="column is-4">
    <div class="control has-icons-left">
        <input @keyup.enter="show_schedule_modal()" v-model="search_course_schedule" class="input" type="text" placeholder="Search Group/Course">
        <span class="icon is-small is-left">
            <i class="fas fa-search"></i>
        </span>
    </div>
</div>
<div class="column is-2">
        <button @click="show_schedule_modal(true)" class="button is-fullwidth has-background-danger has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-minus-circle"></i></span>     
        </button> 
</div>



</div>
<!-- END HEADER  -->


<div class="columns is-multiline box has-background-grey">
<div class="column is-3 isLink" style="" v-for ="(data, index) in data_sched_course_select" :key="index">
<div class="columns is-multiline is-gapless">
    <div @click="data.doSchedule=!data.doSchedule" class="column is-9 colBorderThin has-background-light has-text-weight-bold">&nbsp;&nbsp;{{data.cour_CODE}}
        <span v-if="data.schedMain_ID > 0" class='is-pulled-right icon is-small has-text-grey-dark mt-1'><i class="fas fa-calendar"></i>&nbsp;&nbsp;</span>
    </div>
    <div @click="data.doSchedule=!data.doSchedule" class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_sessann(data.group_SESS)">{{data.group_SESS}}{{data.group_ANN}}</div>
    <div @click="data.doSchedule=!data.doSchedule" class="column has-text-black has-background-white is-3 colBorderThin is-size-7">&nbsp;{{data.group_CODE}}</div>
    <div @click="data.doSchedule=!data.doSchedule" class="column has-text-black has-background-white is-2 colBorderThin has-text-centered is-size-7">{{data.group_LANG}}</div>
    <div @click="data.doSchedule=!data.doSchedule" class="column has-text-black has-background-white is-7 colBorderThin has-text-centered is-size-7">{{data.group_datSTART | moment('DDMMM')}}&nbsp;&nbsp;{{data.group_datEND | moment('DDMMM')}}</div>
    
    <div v-if="+data.doSchedule" class="column is-12">
        <div class="columns is-gapless is-multiline">
            <div class="column is-6 mt-2 is-size-7 has-text-centered has-text-weight-bold"> Shed Code </div>
            <div class="column is-6 is-size-7"><input v-model="data.cour_SCHED" class="input is-small has-text-centered has-text-weight-bold has-background-grey-dark has-text-white" type="text" placeholder="Code"></div>
<!-- get_classrooms(true,index) -->
            <div class="column is-12">
                    <button @click="schedule_begin(index)" class="button is-small is-fullwidth has-background-success has-text-white">
                        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
                    </button> 
            </div>  
        </div>
</div>
</div></div>

    <div class="column is-8"></div>
    <div class="column is-4">
            <button @click="close_schedule_modal()" class="button is-fullwidth has-background-danger has-text-white">
                <span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span>     
            </button> 
    </div>

</div>
<!-- END MAIN COLUMNS  -->

        </div>
    </div>
</div>
<!-- END MODAL SHED !  -->




<div class="columns is-vcentered is-gapless is-mobile has-background-grey-dark" style="">
    <div class="column is-1">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-right"></i></span>     
        </button> 
    </div>
    <div class="column is-9 has-text-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold" :class="return_text_size('is-size-5','is-size-7')">
        Calendrier des cours &nbsp;&nbsp;
    </div>

  <div v-if="showScheduling==false" class="column has-text-centered is-1 has-text-right has-text-weight-light is-size-6" style="margin-bottom:-.2em;"> 
      <button v-print="'#printME'"  class="button is-fullwidth has-background-info-light"><span class="icon is-small has-text-grey"> <i class="fas fa-print"></i> </span></button>
  </div>


    <div v-if="showScheduling==false" class="column is-1 has-tooltip-bottom has-tooltip-success" data-tooltip="Nouveau Schedule">
        <button :disabled="check_access()" @click="show_schedule_modal(true)" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
    <div v-else class="column is-2 has-tooltip-bottom has-tooltip-danger" data-tooltip="Cancel Schedule">
        <button @click="show_schedule_mode(false)" class="button is-fullwidth has-background-danger has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-trash"></i></span>     
        </button> 
    </div>


</div>

<!--  -->




<div id="mySidebar" class="sidebar has-background-grey-dark" style="margin-top:3.7em;">

<div v-if="showScheduling" class="box is-radiusless has-background-grey-dark" style="margin-bottom:.4em;">
    <div class="columns is-gapless is-multiline has-text-white mt-4">

    <div class="column is-10 is-size-3 has-text-weight-bold mt-2 has-text-grey-lighter">
       Schedule
    </div>

    <!-- <div class="column is-2">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
        </button> 
    </div> -->

<div v-if="show_change_defaults" class="column is-12">
<div class="columns is-gapless is-multiline">
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">Date de début</div>
    <div class="column is-12">
        <flat-pickr 
            v-model="sched_dt_s"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
 </div>
 </div>
</div>
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">Date de début</div>
    <div class="column is-12">
        <flat-pickr 
            v-model="sched_dt_e"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
 </div>
 </div>
</div>

 <!-- SCHEDULING OPTIONS TIME -->
<div v-if="+showScheduling==true" class="column mt-3 is-12 box has-background-light" style="">
<div class="columns is-gapless is-multiline">
   <div class="column is-4 has-text-centered"><input v-model="sched_time_AM" type="checkbox"> AM</div> 
   <div class="column is-4 has-text-centered"><input v-model="sched_time_PM" type="checkbox"> PM</div>
   <div class="column is-4 has-text-centered"><input v-model="sched_time_SOIR" type="checkbox"> SOIR</div>
</div></div>
<!-- SCHEDULING OPTIONS ROOM -->
<div v-if="+showScheduling==true" class="column mt-3 is-12 box has-background-light" style="">
<div class="columns is-gapless is-multiline">
   <div class="column is-6 colBorderThinTopBottom is-size-7" v-for ="(data, index) in data_rooms" :key="index">&nbsp;<input v-model="data_rooms[index].isSelected" type="checkbox"> {{data.schedRoom_DESC}}</div> 
</div></div>


<div class="column is-12 mt-2">
    <button @click="schedule_begin_set_grid()" class="button is-small is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i> &nbsp;&nbsp;&nbsp;&nbsp;SET GRID!</span>     
    </button> 
</div>
</div></div>

<div v-else class="column is-12" style="">
<div class="columns is-multiline is-gapless">






<div class="column is-1"></div>
    <div @click="show_change_defaults=true" class="column is-10 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold ">
         {{ sched_dt_s | moment("MMM DD")}} - {{sched_dt_e | moment("MMM DD") }}
    </div>
<div class="column is-1"></div>
</div></div> 









<div class="column is-12" style=""> &nbsp; </div>


<div class="column is-2">
    <button @click="schedule_course_menu_add(index)" class="button is-small is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
    </button> 
</div>
<div class="column is-10 is-size-7 has-text-weight-bold mt-3"> &nbsp;&nbsp;&nbsp;ADD COURSE </div>

<div class="column is-12">
<div class="columns is-gapless colBorderThin is-vcentered is-multiline has-text-white" style="margin-bottom:0em;" v-for ="(data, index) in data_courses" :key="index">

<div v-if="data.dt" class="column is-8">
    &nbsp;&nbsp;{{data.dt | moment("add", "1 days",'DD-MMM-YY')}}
</div>
<div v-else class="column is-8">
    &nbsp;&nbsp;{{data.name}}
    <span @click="schedule_course_menu_remove(index)" v-if="index!=0" class="is-pulled-right is-size-7 has-text-danger">DEL.&nbsp;&nbsp;</span>
</div>


<div v-if="data.dt" class="column is-4">
    <button @click="schedule_course_clear(index)" class="button is-fullwidth has-background-danger has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-calendar-times"></i></span>     
    </button> 
</div>
<div v-else class="column is-4">

<!-- CHECK IF 2 PROFS  -->
<div v-if="sched_prof_2_id > 0" class="columns is-gapless">

    <div class="column is-6">
        <button @click="schedule_course_select(index, sched_prof_1_id)" class="button is-fullwidth has-background-success has-text-white">
            {{sched_prof_1_name}}
        </button>
    </div>

    <div class="column is-6">
        <button @click="schedule_course_select(index, sched_prof_2_id)" class="button is-fullwidth has-background-success has-text-white">
            {{sched_prof_2_name}}
        </button>
    </div>


</div> <!-- END CHECK 2 PROFS  -->
<div v-else class="columns is-gapless">
    <div class="column is-12">
        <button @click="schedule_course_select(index, sched_prof_1_id)" class="button is-fullwidth has-background-success has-text-white">
            {{sched_prof_1_name}}
        </button>
    </div>
</div>



    <!-- <button @click="schedule_course_select(index)" class="button is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-calendar-plus"></i></span>     
    </button>  -->


</div>




</div></div>


     <div class="column is-3 mt-6">
        <button @click="get_classrooms(false)" class="button is-fullwidth has-background-danger has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span>     
        </button> 
    </div>

     <div class="column is-9 mt-6">
        <button @click="schedule_save()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-save"></i></span>     
        </button> 
    </div>





    </div>
</div>
<!-- ------------------   END SHOW NEW -------------------v-model="data_courses"  -->
<!-- ------------------   END SHOW NEW -------------------  -->
<!-- ------------------   END SHOW NEW -------------------  -->
<!-- ------------------   END SHOW NEW -------------------  -->


<!-- DISPLAY VIEW  -->
<div v-else class="box is-radiusless has-background-grey-dark" style="margin-bottom:.4em;"> 

<div class="columns is-gapless is-multiline mt-4">


    <div class="column is-10 is-size-3 has-text-weight-bold mt-2 has-text-grey-lighter">
       Schedule
    </div>

    <div class="column is-2">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
        </button> 
    </div>




<div class="column is-12" style="">
<div class="columns is-multiline is-gapless">
<div class="column is-1"></div>
    <div @click="show_change_display_dates=!show_change_display_dates" class="column is-10 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold ">
         {{ sched_dt_s | moment("MMM DD")}} - {{sched_dt_e | moment("MMM DD") }}
    </div>
<div class="column is-1"></div>
</div></div> 

<!-- CALENDAR DATA CHANGE  -->
<div v-if="show_change_display_dates" class="column is-12 mt-3">
<div class="columns is-gapless is-multiline">
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
<div class="column is-12 isLabel">Date de début</div>
<div class="column is-12">
        <flat-pickr 
            v-model="sched_dt_s"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
</div></div></div>
<div class="column is-6" style="">
<div class="columns is-gapless is-multiline">
<div class="column is-12 isLabel">Date de début</div>
<div class="column is-12">
        <flat-pickr 
            v-model="sched_dt_e"
            class="input is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
</div></div></div>
<div class="column is-12 mt-2">
    <button @click="get_classrooms(false,0)" class="button is-small is-fullwidth has-background-success has-text-white">
        <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;SET DATES     
    </button> 
</div></div></div>
<!-- END CALENDAR DATA CHANGE  -->

<div class="column is-12 mt-6" style="">
<div class="columns is-multiline is-gapless box has-background-grey">

    <!-- <div class="column is-10 has-text-centered has-text-weight-bold">
            <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="sort_search()" class="input is-fullwidth" type="text" placeholder="search">
            <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div>
    <div @click="clear_search_search()" class="column colBorderThin is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
    </div> -->


<div class="column is-12 has-text-white">Filtres de calendrier</div>

<div class="column is-1 is-size-7 has-text-light mt-2"> G. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="search_group" @change="search_schedule_sort()">
            <!-- <option value=""></option> -->
            <option v-for="(data,index) in data_filter_groups" :value="data"  :key="index" >{{ data }}</option>
        </select>
</div></div>
<div @click="search_schedule_clear_g()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>

<div class="column is-1 is-size-7 has-text-light mt-2"> C. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="search_course" @change="search_schedule_sort()">
            <!-- <option value=""></option> -->
            <option v-for="(data,index) in data_filter_cours" :value="data.cour_id"  :key="index" >{{ data.cour_code }}</option>
        </select>
</div></div>
<div @click="search_schedule_clear_c()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>

<div class="column is-1 is-size-7 has-text-light mt-2"> P. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="search_prof" @change="search_schedule_sort()">
            <!-- <option value=""></option> -->
            <option v-for="(data,index) in data_filter_profs" :value="data.prof_id"  :key="index" >{{ data.prof_name }}</option>
        </select>
</div></div>
<div @click="search_schedule_clear_p()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>

</div></div>


</div>  <!-- end main columns -->
</div>  <!-- end box -->
</div>
<!-- END SIDEBAR  -->

<div id="mainContent" style="margin-top:-1.5em;" >
<div id="printME">

    <div class="columns is-multiline is-gapless" v-for="indexMain in data_days_calendar.length" :key="indexMain">       


<!-- <div v-if="indexMain==1" class="column is-1 has-text-left has-background-grey-dark has-text-weight-bold has-text-warning">&nbsp;&nbsp;<span class="is-size-7">WK</span> {{return_week_number(moment(data_days_calendar[indexMain-1][0].dt))}} XX</div> -->
<div class="column is-1 has-text-left has-background-grey-dark has-text-weight-bold has-text-warning">&nbsp;&nbsp;<span class="is-size-7">WK</span> {{return_week_number(moment(data_days_calendar[indexMain-1][0].dt))}}</div>




<div class="column is-11">
<div class="columns is-gapless has-text-centered has-text-weight-bold has-background-grey has-text-white">
<div class="column is-2 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][0].dt).format('ddd-MMM DD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][0].dt)" v-if="contact_check(data_days_calendar[indexMain-1][0].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-2 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][1].dt).format('ddd-MMM DD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][1].dt)" v-if="contact_check(data_days_calendar[indexMain-1][1].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-2 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][2].dt).format('ddd-MMM DD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][2].dt)" v-if="contact_check(data_days_calendar[indexMain-1][2].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-2 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][3].dt).format('ddd-MMM DD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][3].dt)" v-if="contact_check(data_days_calendar[indexMain-1][3].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-2 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][4].dt).format('ddd-MMM DD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][4].dt)" v-if="contact_check(data_days_calendar[indexMain-1][4].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-1 colBorderThinRight">{{ moment(data_days_calendar[indexMain-1][5].dt).format('dddDD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][5].dt)" v-if="contact_check(data_days_calendar[indexMain-1][5].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
<div class="column is-1">{{ moment(data_days_calendar[indexMain-1][6].dt).format('dddDD') }}
    <span @click="contact_click(data_days_calendar[indexMain-1][6].dt)" v-if="contact_check(data_days_calendar[indexMain-1][6].dt)" class="icon mt-1 is-small is-pulled-right has-text-warning has-tooltip-left has-tooltip-warning" data-tooltip="Send Message"><i class="fas fa-comment-alt"></i>&nbsp;&nbsp;</span>
</div>
</div></div> 

 <!--  -->
 
<div class="column is-1">
    <div class="columns is-gapless colBorderBottom is-multiline has-background-warning-light" style="margin-bottom:0em;">
        <div class="column is-12" v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom">




        <div v-if="schedule_display_check_range(data.schedRoom_ID,'AM',data_days_calendar[indexMain-1][0].dt)" class="columns is-gapless colBorderThin" style="margin-bottom:0em;" >  


            <div class="column is-12 is-size-7 has-text-weight-bold">&nbsp;{{data.schedRoom_DESC}}</div>


        </div>


       
        
        </div>
    </div>
    <div class="columns is-gapless colBorderBottom is-multiline has-background-success-light" style="margin-bottom:0em;">
        <!-- <div class="column is-4">PM</div> -->
        <div class="column is-12" v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom">
        <div v-if="schedule_display_check_range(data.schedRoom_ID,'PM',data_days_calendar[indexMain-1][0].dt)" class="columns is-gapless colBorderThin" style="margin-bottom:0em;" >    
            <div class="column is-12 is-size-7 has-text-weight-bold">&nbsp;{{data.schedRoom_DESC}}</div>
        </div></div>
    </div>
    <div class="columns is-gapless is-multiline has-background-danger-light">
        <!-- <div class="column is-4">SOIR</div> -->
        <div class="column is-12" v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom">
        <div v-if="schedule_display_check_range(data.schedRoom_ID,'SOIR',data_days_calendar[indexMain-1][0].dt)" class="columns is-gapless colBorderThin" style="margin-bottom:0em;" >    
            <div class="column is-12 is-size-7 has-text-weight-bold">&nbsp;{{data.schedRoom_DESC}}</div>
        </div></div>
    </div>
</div>  <!-- END COLUMN ONE  -->
            




<div class="column is-11">
<div class="columns is-gapless is-multiline">

 <!-- -->

<div class="column" :class="return_col_width(indexDay)" v-for="indexDay in 7" :key="indexDay*1000+55">
 <!-- :class="return_col_width(indexDay-1)" -->
<!-- <div> MONDAY  -->

    
<div v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom+indexMain+'AM'"> 
    
<!-- :val="schedule_course_get(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'AM')" -->


<!-- <draggable v-model="data_days_calendar" group="cal" @end="endDrag"> -->
<ScheduleBox v-if="schedule_display_check_range(data.schedRoom_ID,'AM',data_days_calendar[indexMain-1][indexDay-1].dt)"
:dt="data_days_calendar[indexMain-1][indexDay-1].dt" :room_id="data_sched_rooms[indexRoom].schedRoom_ID" time="AM"
:val="schedule_course_get(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'AM')"
:colour="schedule_course_get_colour(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'AM')"
:group_id="data_sched_rooms[indexRoom].group_ID"
:key="indexMain+indexDay+'AM'"
></ScheduleBox>
<!-- </draggable> -->

</div>

<!-- BORDER  -->
<div class="columns is-gapless colBorderBottom" style="margin-bottom:0em;"></div>

<div v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom+indexMain+'PM'">
<ScheduleBox v-if="schedule_display_check_range(data.schedRoom_ID,'PM',data_days_calendar[indexMain-1][indexDay-1].dt)"  
:dt="data_days_calendar[indexMain-1][indexDay-1].dt" :room_id="data_sched_rooms[indexRoom].schedRoom_ID" time="PM"
:val="schedule_course_get(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'PM')"
:colour="schedule_course_get_colour(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'PM')"
:group_id="data_sched_rooms[indexRoom].group_ID"
:key="indexMain+indexDay+'PM'"
></ScheduleBox>
</div>


<div class="columns is-gapless colBorderBottom" style="margin-bottom:0em;"></div>

<div v-for="(data,indexRoom) in data_sched_rooms" :key="indexRoom+indexMain+'SOIR'">
<ScheduleBox v-if="schedule_display_check_range(data.schedRoom_ID,'SOIR',data_days_calendar[indexMain-1][indexDay-1].dt)" 
:dt="data_days_calendar[indexMain-1][indexDay-1].dt" :room_id="data_sched_rooms[indexRoom].schedRoom_ID" time="SOIR"        
:val="schedule_course_get(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'SOIR')"
:colour="schedule_course_get_colour(data_days_calendar[indexMain-1][indexDay-1].dt, data_sched_rooms[indexRoom].schedRoom_ID, 'SOIR')"
:group_id="data_sched_rooms[indexRoom].group_ID"
:key="indexMain+indexDay+'SOIR'"
></ScheduleBox>
</div>


<!-- </div> END MONDAY  -->

<!-- //////////////////////////////////////////////////////////////////// -->

</div> <!-- END DAY LOOP DIV  -->

</div>



</div>
</div>

    <!-- END SHOW SCHEDULE  -->


</div> </div>
<!-- MAIN CONTENT  -->

</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';
import { bus } from '@/main'
import ScheduleBox  from '@/components/Comp_Schedule_Box';

import draggable from "vuedraggable";

import Calendar from '@/components/Comp_Calendar'
import eachDayOfInterval from 'date-fns/eachDayOfInterval' 
import isWeekend from 'date-fns/isWeekend'
import getMonth from 'date-fns/getMonth'
import Transmission from './Transmission.vue';

import CompRetards  from '@/components/Comp_Group_Retards';
import Contact from '@/components/Comp_Contact'

export default {
        props: [],
        components: { Calendar  , ScheduleBox , Contact , CompRetards },

        data() {
            return {
                 isLoading:false,
                 view_calendar:true,
                 view_schedule:false,


show_change_defaults:false,

sched_dt_s : moment().format('YYYY-MM-DD'),
sched_dt_e : moment().add(14,'days').format('YYYY-MM-DD'),

dt_calendar: moment().add(-7, 'days').format('YYYY-MM-DD'),
data_events:[],
data_groups:[],
data_sched:[],
data_profs:[],

selected_schedule:'',

selected_campus:'',

detail_start:'',
detail_end:'',
detail_courses:'',
detail_students:'',
 
isProf : false,

selected_group:'',
show_detail_index:-1,
selected_prof:'',

navOpen:false,

showScheduling:false ,
doHighLighting:false,
sched_new_count : 10,

sched_group_id : 0,
sched_group_code : '',

data_days_schedule : [] ,
data_days_calendar : [] ,

data_sched_rooms : [] ,
indexMain : 0,

is_scheduling : false, // DENOTES COURSE SELECTED FOR SCHEDULING
is_scheduling_index : -1,
is_scheduling_prof : -1,

data_rooms : [],
sched_time_AM:false,
sched_time_PM:false,
sched_time_SOIR:false,

data_calendar_check : [], // HOLDS DATA FOR HIDING/SHOWING WEEKS

data_sched_course_select : [] ,

data_courses: [],


 // HOLDS COUR DATA GETTING SCHEDED
sched_prof_1_name:'',
sched_prof_1_id:'',
sched_prof_2_name:'',
sched_prof_2_id:'',


data_filter_groups:[],
data_filter_profs:[],
data_filter_cours:[],

data_contact:[],

search_course_schedule:'',

// FILTER CALENDAR
search_group:'',
search_course:'',
search_prof:'',
search_QUERY:'',

show_change_display_dates:false,

retard_group_id:-1,


config: { // FLATPICKER
    altFormat: "M j, y",
    altInput: true,
    disableMobile: true
},

            }
        },

  watch: {
    // isDragging(newValue) {
    //   if (newValue) {
    //     this.delayedDragging = true;
    //     return;
    //   }
    //   this.$nextTick(() => {
    //     this.delayedDragging = false;
    //   });
    // }
  },
  computed: {
    // dragOptions() {
    //   return {
    //     animation: 0,
    //     group: "description",
    //     ghostClass: "ghost",
    //     onEnd : function (evt) {
    //         alert(evt)
    //         // evt.oldIndex;  // element's old index within parent
    //         // evt.newIndex;  // element's new index within parent
    //         // console.log("drag onEnd", evt.newIndex)
    //     },
    //   };
    // },
  },

mounted() {

// GET LIST OF CLASSROOMS (FOR SCHEDULING)
var query = "SELECT 0 AS isSelected,schedRoom_ID,schedRoom_DESC  FROM myMEQ_SCHEDULE_ROOM ORDER BY schedRoom_DESC"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + query)
.then(res => { 
    this.data_rooms = res.data 
    this.get_classrooms(false)
});

   

},


created() {


bus.$on('bus_course_set' ,(dt , roomID, time)  => {
// ADD TO CALENDAR 
if (!this.is_scheduling) {return}

    var keyFind = dt + "|" + roomID + "|" + time
    var keyIndex = this.data_days_schedule.findIndex(x => x.key === keyFind);
    this.data_days_schedule[keyIndex].val = this.data_days_schedule[keyIndex].val + " " + this.data_courses[this.is_scheduling_index].name

    this.data_days_schedule[keyIndex].colour = this.data_courses[this.is_scheduling_index].colour

    this.data_courses[this.is_scheduling_index].dt = dt
    this.data_courses[this.is_scheduling_index].sched_key = keyFind
    this.data_courses[this.is_scheduling_index].staff_ID = this.is_scheduling_prof
    this.is_scheduling = false

})


// this.isLoading=true;

//     //CHECK PROF 
//     if (sessionStorage.getItem('user_level') == 'PROF') {
//         this.selected_prof = sessionStorage.getItem('user_name')  
//         this.isProf = true 
//     }

// // GET GROUP START DATE
// var dtGrp = moment().add(-60, 'days').format('YYYY-MM-DD')

// // GET GROUP CODES
// var sql =  "SELECT DISTINCT  MyMEQ_GROUP.group_CODE, MIN(MyMEQ_GROUP.group_datSTART) AS dtS, MAX(MyMEQ_GROUP.group_datEND) AS dtE,  COUNT(DISTINCT MyMEQ_COURSESTUDENT.student_ID) AS cntStud, COUNT(DISTINCT MyMEQ_GROUP.cour_ID) AS cntCour FROM  MyMEQ_GROUP INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_GROUP.group_ID = MyMEQ_COURSESTUDENT.group_ID WHERE group_datSTART >= '" + dtGrp +  "' group by group_CODE "
// sql +=  sessionStorage.getItem('sql_prof') + "  ORDER BY group_CODE"
// axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
// .then(res => { this.data_groups = res.data 


// // GET SCHEDULE CODES 
// var sql =  "SELECT * FROM  myMEQ_SCHEDULE_GROUP WHERE schedGrp_minDate >= '" + dtGrp +  "' "
// sql +=  sessionStorage.getItem('sql_prof') + "  ORDER BY schedGrp_CODE"
// axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
// .then(res => { this.data_sched = res.data 

// // PROF -- TODAY ON ONLY!
// dtGrp = moment().format('YYYY-MM-DD')
// var query = "SELECT DISTINCT MyMEQ_STAFF.staff_ID, MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof, MIN(myMEQ_SCHEDULE_MAIN.schedMain_date) AS dtS FROM myMEQ_SCHEDULE_MAIN INNER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID  WHERE schedMain_date >= '" + dtGrp +  "' GROUP BY MyMEQ_STAFF.staff_ID, MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom ORDER BY prof"
// console.log(query)
// axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
// .then(res => { this.data_profs = res.data 





// var query = "SELECT * FROM myMEQ_SCHEDULE_ROOM ORDER BY schedRoom_DESC"
// console.log(query)
// axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
// .then(res => { this.data_sched_rooms = res.data 


// this.isLoading=false;
// this.get_schedule()

// setTimeout(() => { if (!this.check_mobile()) {this.openNav();} }, 500);

// });
// });
// }); 
// });


}, // END CREATED!

methods : {



contact_check:function(key) {

    var bReturn = false
    for (var i = 0; i < this.data_days_schedule.length; i++) {
        if (this.data_days_schedule[i].dt == key && this.data_days_schedule[i].val != '')
        {bReturn =  true ; break;} 
    }

    return bReturn

},
// END CHECK IF HAS COURSE -- SHOW CONTACT BUTTON   
contact_click:function(key) {
    this.isLoading = true;
    
// FILTER PROF
var sql = ` (myMEQ_SCHEDULE_MAIN.schedMain_date = '` + key + `') `
if (sessionStorage.getItem('user_level') === 'PROF') {sql += sessionStorage.getItem('sql_prof')}



    var query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_fNAME,  MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_eMail, MyMEQ_STUDENT.student_TelHome
    , 1 AS goodToGo FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN myMEQ_SCHEDULE_MAIN ON MyMEQ_GROUP.group_ID = myMEQ_SCHEDULE_MAIN.group_ID
    WHERE ` + sql + ` ORDER BY student_lNAME`
// console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        
        this.data_contact = res.data
        document.querySelector('#myModalContact').classList.add('is-active');
        this.isLoading = false;
    });
},
// END CONTACT CLICK ----
close_contact_modal:function(isSent) {
    document.querySelector('#myModalContact').classList.remove('is-active');
    
    if (isSent==true) {
        this.$snotify.success(' SENT !!', {
            timeout: 500,showProgressBar: true,closeOnClick: false,pauseOnHover: false
        }); 
    }
},


close_modal_retards:function() {
    document.querySelector('#myModalRetards').classList.remove('is-active');
},
emit_open_modal_retards:function(gID) {
    document.querySelector('#myModalRetards').classList.add('is-active');
},




endDrag:function(evt) {
    console.log(evt)
},


return_col_width:function(index) {
    if (index < 6) {return 'is-2'}
    else {return 'is-1'}
},


schedule_display_check_range_XX:function(room_id, time, dt) {

console.log((parseFloat(moment(dt).format('WW'))))

},



schedule_display_check_range:function(room_id, time, dt) {
// CHECK IF WEEK HAS DATA -- DISPLAY MODE
    if (+this.showScheduling == true) { 
console.log(time) 
        if (time=='AM') {return this.sched_time_AM}
        if (time=='PM') {return this.sched_time_PM}
        if (time=='SOIR') {return this.sched_time_SOIR}

    }



    var chk = room_id + time + (parseFloat(moment(dt).format('WW')))
    var keyIndex = this.data_calendar_check.findIndex(x => x.chkCode === chk);  
    if (keyIndex > -1) { return true } else { return false }

},



get_classrooms:function(schedMode , index) {

document.querySelector('#myModalSchedule').classList.remove('is-active');
this.data_courses = []
// GET LIST OF CLASSROOMS 
// IF SCHEDULING - SHOW ALL - ELSE - FILTER ROOMS
this.isLoading=true;
var query = ''


this.showScheduling = schedMode

    if (+schedMode == false) {
      //  this.sched_group_id = 0

var dtMON = moment(this.sched_dt_s).subtract(7,'days').startOf('isoWeek').format('YYYY-MM-DD') 
var dtSUN = moment(this.sched_dt_e).endOf('isoWeek').format('YYYY-MM-DD')
var dtSQL = ` schedMain_date BETWEEN '` + dtMON + `' AND '` + dtSUN + `' `

if (sessionStorage.getItem('user_level') === 'PROF') {dtSQL += sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP")}


        query = `SELECT DISTINCT myMEQ_SCHEDULE_MAIN.schedRoom_ID, myMEQ_SCHEDULE_ROOM.schedRoom_DESC , CONCAT(myMEQ_SCHEDULE_MAIN.schedRoom_ID , schedMain_AmPmSoir, DATEPART(wk,schedMain_date ) - 1) AS chkCode, DATEPART(wk,schedMain_date ) - 1 as weeker 
        , myMEQ_SCHEDULE_MAIN.group_ID
        FROM MyMEQ_GROUP AS GRP INNER JOIN
        myMEQ_SCHEDULE_MAIN ON GRP.group_ID = myMEQ_SCHEDULE_MAIN.group_ID INNER JOIN
        myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID         
        
        `

        if (this.search_QUERY != '') {
            query += ` WHERE ` + dtSQL + this.search_QUERY
        } else {
            query += ` WHERE ` + dtSQL
        }

 console.log(query)

    } else {

        

        query = "SELECT * FROM myMEQ_SCHEDULE_ROOM ORDER BY schedRoom_DESC"
        // CHECK IF WE HAVE A COURSE
        // if (index > 0 ) {
            this.sched_dt_s = this.data_sched_course_select[index].group_datSTART
            this.sched_dt_e = this.data_sched_course_select[index].group_datEND
            this.sched_group_id = this.data_sched_course_select[index].group_ID
            this.sched_group_code = this.data_sched_course_select[index].cour_SCHED



this.sched_prof_1_name = this.data_sched_course_select[index].prof1_initial
this.sched_prof_1_id=0 
if (this.data_sched_course_select[index].prof1) 
{this.sched_prof_1_id = this.data_sched_course_select[index].prof1_ID}
else {this.sched_prof_1_name = '?'}

this.sched_prof_2_name = this.data_sched_course_select[index].prof2_initial
this.sched_prof_2_id=0
if (this.data_sched_course_select[index].prof2) {this.sched_prof_2_id = this.data_sched_course_select[index].prof2_ID}


        // }

    }
     
    // console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_calendar_check = res.data // DATA FOR HIDE/SHOW

        // GET UNIQUE FOR WHEN IN DISPLAY MODE
        for (var i = 0; i < res.data.length; i++) {
            var keyIndex = this.data_sched_rooms.findIndex(x => x.schedRoom_ID === res.data[i].schedRoom_ID);
            if (keyIndex == -1) {this.data_sched_rooms.push(res.data[i])}
        }

// this.data_sched_rooms = res.data 



//  this.data_sched_rooms = [...new Set( res.data.map(obj => obj.schedRoom_ID)) ];

        this.calendar_load_everything()
    

    });



},

schedule_begin_set_grid:function() {

// CHECK VALUES
if (this.sched_time_AM==false && this.sched_time_PM==false && this.sched_time_SOIR==false) {
    alert ('Select Time') ; return ;
} // END CHECKING TIME

// CHECK CLASSROOMS
this.data_sched_rooms = []
for (var i = 0; i < this.data_rooms.length; i++) {
    if (this.data_rooms[i].isSelected == true)
    {this.data_sched_rooms.push(this.data_rooms[i])}
} // END LOOP ROOMS
if (this.data_sched_rooms.length == 0) {
    alert ('Select Room(s)') ; return ;   
} // END CHECKING ROOMS

this.calendar_load_everything()
// alert ('----here----')
},


schedule_begin:function(index) {
  // NEW SCHEDULE (OR EXISTING) ---- INDEX OF GROUP

// dt
    this.sched_dt_s = this.data_sched_course_select[index].group_datSTART
    this.sched_dt_e = this.data_sched_course_select[index].group_datEND

    this.data_filter_profs = []
    this.data_filter_cours = []
    this.data_days_schedule = []
    this.data_days_calendar = []

       
this.sched_group_code = this.data_sched_course_select[index].cour_SCHED
this.sched_group_id = this.data_sched_course_select[index].group_ID

this.sched_prof_1_name = this.data_sched_course_select[index].prof1_initial
this.sched_prof_1_id=0 
if (this.data_sched_course_select[index].prof1) 
{this.sched_prof_1_id = this.data_sched_course_select[index].prof1_ID}
else {this.sched_prof_1_name = '?'}

this.sched_prof_2_name = this.data_sched_course_select[index].prof2_initial
this.sched_prof_2_id=0
if (this.data_sched_course_select[index].prof2) {this.sched_prof_2_id = this.data_sched_course_select[index].prof2_ID}




    document.querySelector('#myModalSchedule').classList.remove('is-active');
    this.data_courses = []
    this.show_change_defaults = true 
    this.showScheduling = true

},




calendar_load_everything:function() {
this.isLoading=true;

// RESET THINGS
this.data_filter_profs = []
this.data_filter_cours = []
this.data_days_schedule = []
this.data_days_calendar = []

    var dtMON = moment(this.sched_dt_s).startOf('isoWeek').format('YYYY-MM-DD')
    var dtSUN = moment(this.sched_dt_e).add(7,'days').endOf('isoWeek').format('YYYY-MM-DD')



    while (dtMON <= dtSUN) {
        var key = moment(dtMON).format('YYYY-MM-DD')
        for (var i = 0; i < this.data_sched_rooms.length; i++) {
            var obj = {};
            obj.key = key + "|" + this.data_sched_rooms[i].schedRoom_ID + "|" + "AM"
            obj.val = ''
            obj.colour = ''
            obj.dt = key
            obj.isSelected = false
            this.data_days_schedule.push(obj);

            var obj = {};
            obj.key = key + "|" + this.data_sched_rooms[i].schedRoom_ID + "|" + "PM"
            obj.val = ''
            obj.colour = ''
            obj.dt = key
            obj.isSelected = false
            this.data_days_schedule.push(obj);

            var obj = {};
            obj.key = key + "|" + this.data_sched_rooms[i].schedRoom_ID + "|" + "SOIR"
            obj.val = ''
            obj.colour = ''
            obj.dt = key
            obj.isSelected = false
            this.data_days_schedule.push(obj);
        } // END FOR
        dtMON = moment(dtMON).add(1,"days").format('YYYY-MM-DD')
    } // END WHILE

    var dtMON = moment(this.sched_dt_s).startOf('isoWeek').format('YYYY-MM-DD')
    var dtSUN = moment(this.sched_dt_e).add(7,'days').endOf('isoWeek').format('YYYY-MM-DD')

// FOR THE CALENDAR DAYS !
    var wks = moment(dtSUN).diff(moment(dtMON),"weeks")


    for (var i = 0; i < wks; i++) {
        var dt = moment(this.sched_dt_s).add((i*7),"days").format('YYYY-MM-DD')
        var dtMON = moment(dt).startOf('isoWeek').format('YYYY-MM-DD')
        var dtSUN = moment(dt).endOf('isoWeek').format('YYYY-MM-DD')
        var temp = []
        while (dtMON <= dtSUN) {
            var obj = {};
            obj.dt = moment(dtMON).format('YYYY-MM-DD')
            obj.val = ''
            temp.push(obj)
            dtMON = moment(dtMON).add(1,"days").format('YYYY-MM-DD')
        }
        this.data_days_calendar.push(temp);
    }
// END CALENDAR DAYS ---------------------

    
    setTimeout(() => { this.schedule_courses_get_scheduled() ; this.openNav(); }, 500);



},
// END LOAD EVERYTHING !!!!
search_schedule_clear_g:function() {
    this.search_group = '';
    this.search_schedule_sort()
},
search_schedule_clear_c:function() {
    this.search_course = ''
    this.search_schedule_sort()
},
search_schedule_clear_p:function() {
    this.search_prof = ''
    this.search_schedule_sort()
},
search_schedule_sort:function() {

   // CHECK FOR NOTHING
   if (this.search_group=='' && this.search_course=='' && this.search_prof=='')
   { this.search_QUERY = `` ; this.get_classrooms(false) ; return }

    var q_grp = ''
    if (this.search_group!='') {q_grp = ` AND (group_CODE = '` + this.search_group + `') `}

    var q_cour = ''
    if (this.search_course!='') {q_cour = ` AND (GRP.cour_ID = ` + this.search_course + `) `}

    var q_prof = ''
    if (this.search_prof!='') {q_prof = ` AND (GRP.staff_ID_1 = ` + this.search_prof + ` OR GRP.staff_ID_2 = ` + this.search_prof + `) `}

    this.search_QUERY = q_grp + q_cour + q_prof
    
    this.get_classrooms(false)

},


schedule_courses_get_scheduled:function() {

var dtMON = moment(this.sched_dt_s).startOf('isoWeek').format('YYYY-MM-DD') 
var dtSUN = moment(this.sched_dt_e).endOf('isoWeek').format('YYYY-MM-DD')
var dtSQL = ` schedMain_date BETWEEN '` + dtMON + `' AND '` + dtSUN + `' `

if (sessionStorage.getItem('user_level') === 'PROF') {dtSQL += sessionStorage.getItem('sql_prof').replace(/MyMEQ_GROUP/g,"GRP")}


    var sql = `SELECT  myMEQ_SCHEDULE_MAIN.*,  FORMAT(schedMain_date, 'yyyy-MM-dd') + '|' + CONVERT(VARCHAR(5), schedRoom_ID) + '|' + schedMain_AmPmSoir AS keyVal ,
    GRP.group_CODE, PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1, PROF1.staff_ID AS prof1_ID, PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID, MyMEQ_COUR.cour_ID, MyMEQ_COUR.cour_CODE,
    PROF1.staff_Initials AS prof1_initial, PROF2.staff_Initials AS prof2_initial
    FROM MyMEQ_GROUP AS GRP INNER JOIN
    myMEQ_SCHEDULE_MAIN ON GRP.group_ID = myMEQ_SCHEDULE_MAIN.group_ID INNER JOIN
    MyMEQ_COUR ON GRP.cour_ID = MyMEQ_COUR.cour_ID LEFT OUTER JOIN
    MyMEQ_STAFF AS PROF2 ON GRP.staff_ID_2 = PROF2.staff_ID LEFT OUTER JOIN
    MyMEQ_STAFF AS PROF1 ON GRP.staff_ID_1 = PROF1.staff_ID `
      
    if (this.search_QUERY != '') {
        sql += ` WHERE ` + dtSQL + this.search_QUERY
    } else {
        sql += ` WHERE ` + dtSQL
    }

   



console.log(sql)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => {  

// FILTER
if (this.search_group == '') this.data_filter_groups = [...new Set(res.data.map(item => item.group_CODE))];

        for (var i = 0; i < res.data.length; i++) {

// COURS
var pIndex = this.data_filter_cours.findIndex(x => x.cour_id === res.data[i].cour_ID);
if (pIndex==-1) {var obj = {}; obj.cour_id = res.data[i].cour_ID; obj.cour_code = res.data[i].cour_CODE;this.data_filter_cours.push(obj);} 


// PROF(S) 
var pIndex = this.data_filter_profs.findIndex(x => x.prof_id === res.data[i].prof1_ID);
if (pIndex==-1) {var obj = {}; obj.prof_id = res.data[i].prof1_ID; obj.prof_name = res.data[i].prof1_initial;this.data_filter_profs.push(obj); }
var pIndex = this.data_filter_profs.findIndex(x => x.prof_id === res.data[i].prof2_ID);
if (pIndex==-1) {var obj = {}; obj.prof_id = res.data[i].prof2_ID; obj.prof_name = res.data[i].prof2_initial;this.data_filter_profs.push(obj); }

            var keyIndex = this.data_days_schedule.findIndex(x => x.key === res.data[i].keyVal);

console.log('********************** ' + keyIndex + ' :: ' + res.data[i].keyVal + '  ********************** ')
if (keyIndex > -1) {
    this.data_days_schedule[keyIndex].val  =  res.data[i].schedMain_CODE   
    this.data_days_schedule[keyIndex].colour  =  res.data[i].schedMain_COLOUR   
}
            

        } // END FOR 
        this.isLoading=false;
        this.show_change_defaults = false
        this.show_change_display_dates = false

setTimeout(() => { if (this.sched_group_id != 0) {this.schedule_start()}  }, 400);


    });
},
// END GET ALL SCHEDULED

// ----------------------------------------------------------------------------------------------------------
schedule_start:function() {



// CHECK IF ALREADY SCHEDULED ....
    // var sql = "SELECT  *,  FORMAT(schedMain_date, 'yyyy-MM-dd') + '|' + CONVERT(VARCHAR(5), schedRoom_ID) + '|' + schedMain_AmPmSoir AS keyVal FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = " + this.sched_group_id 

var sql = `SELECT 
myMEQ_SCHEDULE_MAIN.*,  FORMAT(schedMain_date, 'yyyy-MM-dd') + '|' + CONVERT(VARCHAR(5), schedRoom_ID) + '|' + schedMain_AmPmSoir AS keyVal,

PROF1.staff_Initials AS prof1_initial, PROF2.staff_Initials AS prof2_initial,

PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1, PROF1.staff_ID AS prof1_ID,
PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID

    FROM MyMEQ_GROUP LEFT OUTER JOIN
    myMEQ_SCHEDULE_MAIN ON MyMEQ_GROUP.group_ID = myMEQ_SCHEDULE_MAIN.group_ID LEFT OUTER JOIN
    MyMEQ_STAFF AS PROF1 ON MyMEQ_GROUP.staff_ID_1 = PROF1.staff_ID LEFT OUTER JOIN
    MyMEQ_STAFF AS PROF2 ON MyMEQ_GROUP.staff_ID_2 = PROF2.staff_ID

    WHERE MyMEQ_GROUP.group_ID = ` + this.sched_group_id 




console.log(sql)

// RESET PROF




    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 


// IF 0 -- NO NOTHING (SCHED/PROF)
if (res.data.length == 0) {
    this.showScheduling = true
    document.querySelector('#myModalSchedule').classList.remove('is-active');
    this.schedule_course_menu_add()
    return ; 
} // END NO PROF

// IF NO SCHED BUT PROF
if (!res.data[0].schedMain_ID) {

    this.showScheduling = true
    document.querySelector('#myModalSchedule').classList.remove('is-active');
    this.schedule_course_menu_add()
    return ; 
} // END NO PROF



        // 
        if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
                    var obj = {};
                    obj.name = res.data[i].schedMain_CODE
                    obj.dt = moment(res.data[i].schedMain_date).format('YYYY-MM-DD')
                    obj.sched_key = res.data[i].keyVal
                    obj.staff_ID = res.data[i].staff_ID
                    this.data_courses.push(obj);   
                    
    // hl SELECTED
    var keyIndex = this.data_days_schedule.findIndex(x => x.key === res.data[i].keyVal);        
    this.data_days_schedule[keyIndex].colour = 'Aqua'

            } // END FOR
        } else {
            this.schedule_course_menu_add()
        }
    });

    this.showScheduling = true
    document.querySelector('#myModalSchedule').classList.remove('is-active');
},
// END LOADING NEW/EXISTING SCHEDULE


schedule_course_menu_remove:function(index) {
// REMOVE COURSE TO SCHEDULE - NOT SCHEDULED
        this.data_courses.splice(index,1);
},

schedule_course_menu_add:function() {
// ADD A COURSE TO SCHEDULE
        var obj = {};
        obj.name = this.sched_group_code + '  cour' + (this.data_courses.length + 1)
        obj.dt = ''
        obj.sched_key = ''
        obj.staff_ID = ''
        this.data_courses.push(obj);
},


schedule_course_select:function(index, prof_id) {
// SELECT COURSE FOR SCHEDULING
    this.is_scheduling = true
    this.is_scheduling_index = index
    this.is_scheduling_prof = prof_id
},


schedule_course_get:function(dt , roomID, time) {
// GET THE VAL FOR THE CAL
    var keyFind = dt + "|" + roomID + "|" + time

    var keyIndex = this.data_days_schedule.findIndex(x => x.key === keyFind);


   
    return this.data_days_schedule[keyIndex].val
},


schedule_course_get_colour:function(dt , roomID, time) {
// GET THE VAL FOR THE CAL
    var keyFind = dt + "|" + roomID + "|" + time
    var keyIndex = this.data_days_schedule.findIndex(x => x.key === keyFind);
    if (keyIndex < 0) {return ''}

    return this.data_days_schedule[keyIndex].colour

// if (this.data_days_schedule[keyIndex].colour) {
// return 'background-color:' + this.data_days_schedule[keyIndex].colour     
// } else {
//     return 'background-color:orange;'
// }




    // if (+this.data_days_schedule[keyIndex].isSelected ==  true)
    // {return 'has-background-warning'}
},


schedule_course_clear:function(index) {
// MENU INDEX -- REMOVE FROM CAL
    var keyFind = this.data_courses[index].sched_key
    var keyIndex = this.data_days_schedule.findIndex(x => x.key === keyFind);

    var x = this.data_courses[index].name
    var newVal = this.data_days_schedule[keyIndex].val.replace(new RegExp(x, 'g'), '');
    this.data_days_schedule[keyIndex].val = newVal
    this.data_days_schedule[keyIndex].colour = ''

    this.data_courses[index].dt = ''
    this.data_courses[index].sched_key = ''

    this.is_scheduling = false
},

schedule_course_set:function(dt , roomID, time) {
// ADD TO CALENDAR 
if (!this.is_scheduling) {return}

    var keyFind = dt + "|" + roomID + "|" + time
    var keyIndex = this.data_days_schedule.findIndex(x => x.key === keyFind);
    this.data_days_schedule[keyIndex].val = this.data_days_schedule[keyIndex].val + " " + this.data_courses[this.is_scheduling_index].name

this.data_days_schedule[keyIndex].colour = this.data_courses[this.is_scheduling_index].colour

    this.data_courses[this.is_scheduling_index].dt = dt
    this.data_courses[this.is_scheduling_index].sched_key = keyFind
    this.is_scheduling = false

},


schedule_save:function() {
this.isLoading = true;
var sql = ''
// F#*K IT -- REMOVE ALL FIRST!
    sql += `DELETE FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = ` + this.sched_group_id + `;`
    for (var i = 0; i < this.data_courses.length; i++) {

var colour = ''
if (i == 0) {colour = 'green'}
if (i == (this.data_courses.length-1)) {colour = 'red'}

        var det = this.data_courses[i].sched_key.split("|")
        sql += `INSERT INTO myMEQ_SCHEDULE_MAIN (group_ID, schedRoom_ID, schedMain_date, schedMain_AmPmSoir, schedMain_CODE,schedMain_COLOUR, staff_ID) VALUES (`
        + this.sched_group_id + `,` + det[1] + `,'` + det[0] + `','` + det[2] + `','` + this.data_courses[i].name + `','` + colour + `',` + this.data_courses[i].staff_ID + `) ; `
    } // END FOR

// UPDATE START/END
sql += ` UPDATE myMEQ_GROUP SET group_datSTART = '` + moment(this.sched_dt_s).format('YYYY-MM-DD') + `', group_datEND = '` + moment(this.sched_dt_e).format('YYYY-MM-DD') + `' WHERE group_ID = ` + this.sched_group_id


console.log(sql)

axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {
        query:encodeURIComponent(sql)
    },
    
})
.then(res => {
    this.isLoading = false;
})

},

show_schedule_mode:function(val) {
    this.showScheduling = false
    this.get_classrooms(false) 
},

show_schedule_modal:function(doClear) {
this.isLoading=true;
// GET COURSES WHERE group_datSTART > ` + dt + `
// var dt = "'" +  moment(this.sched_dt_s).subtract(21,'days').format('YYYY-MM-DD') + "'"

if (doClear) {this.search_course_schedule = ''}

var qWhere = ''
if (this.search_course_schedule != '')
{qWhere = ` WHERE (group_CODE LIKE '%25` + this.search_course_schedule + `%25') OR (cour_CODE LIKE '%25` + this.search_course_schedule + `%25') `}


var query = `SELECT TOP(20) MyMEQ_GROUP.group_ID, MyMEQ_GROUP.group_CODE, MyMEQ_GROUP.group_datSTART, 
MyMEQ_GROUP.group_datEND, MyMEQ_GROUP.group_LANG,   MyMEQ_COUR.cour_CODE, 
PROF1.staff_Prenom + ' ' + PROF1.staff_Nom AS prof1, PROF1.staff_ID AS prof1_ID,  PROF2.staff_Prenom + ' ' + PROF2.staff_Nom AS prof2, PROF2.staff_ID AS prof2_ID,
PROF1.staff_Initials AS prof1_initial, PROF2.staff_Initials AS prof2_initial
,0 AS doSchedule, MyMEQ_COUR.cour_SCHED, MyMEQ_GROUP.group_SESS, MyMEQ_GROUP.group_ANN, R.schedMain_ID FROM  MyMEQ_GROUP INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF1 ON MyMEQ_GROUP.staff_ID_1 = PROF1.staff_ID LEFT OUTER JOIN MyMEQ_STAFF AS PROF2 ON MyMEQ_GROUP.staff_ID_2 = PROF2.staff_ID 
 OUTER APPLY (SELECT TOP 1 schedMain_ID FROM myMEQ_SCHEDULE_MAIN WHERE group_ID = MyMEQ_GROUP.group_ID) R  
 ` + qWhere + ` ORDER BY group_datEND DESC`

// console.log(query)


    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { this.data_sched_course_select = res.data 
        this.isLoading=false;
    });
    document.querySelector('#myModalSchedule').classList.add('is-active');
},
close_schedule_modal:function() {
    document.querySelector('#myModalSchedule').classList.remove('is-active');
},




schedule_cancel:function() {
// CANCEL NEW SCHEDULE ....
    this.showScheduling = false
},

return_week_number:function(dt) {
    return moment(dt, "MMDDYYYY").isoWeek();
},


fix_pond:function(){

this.isLoading = true;

// STEP ONE -----------------
// var query = `SELECT DISTINCT group_ID,group_AVG FROM MyMEQ_GROUP WHERE (group_AVG <> 'NaN')`
// axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + query)
// .then(res => { this.data_groups = res.data 
//     var sql = ''
//     this.data_groups.forEach(function(data){ 

// var avg = 'NULL'
// if (parseFloat(data.group_AVG)>-1) {avg = data.group_AVG}

//         sql += " INSERT INTO MyMEQ_PROF_PONDERATION " 
//         sql += " (group_ID ,ponderation_Desc ,ponderation_Percent ,ponderation_Max ,ponderation_Order ,ponderation_PUBLIC,ponderation_AVG) VALUES ("
//         sql += data.group_ID + ",'" + 'NOTE' + "','" + '100' + "','" + '100' + "'," + '1' + "," + "1" + "," + avg + ");"
//     });

// // 

//     // let formData = new FormData();
//     // formData.append('query', encodeURIComponent(sql));
//     axios({
//         method: 'post',
//         url: this.$url+sessionStorage.getItem('url_query_form'),
//         data: {query:encodeURIComponent(sql)},
//     })
//     .then(res => {
//         this.isLoading = false;
//     })
// });


// STEP TWO -----------------
var query = `
SELECT MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_COURSESTUDENT.group_ID, MyMEQ_PROF_PONDERATION.ponderation_ID, MyMEQ_COURSESTUDENT.cs_MARK 
FROM MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_PROF_PONDERATION ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_PROF_PONDERATION.group_ID `
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + query)
.then(res => { 


    var sql = ''
    for (var i = 0; i < res.data.length; i++) {

var note = 'NULL'
if (parseFloat(res.data[i].cs_MARK)>-1) {note = res.data[i].cs_MARK}

            sql +=  "INSERT INTO MyMEQ_PROF_NOTES (ponderation_ID, cs_ID,note_NOTE) VALUES ("
            sql += res.data[i].ponderation_ID + "," + res.data[i].cs_ID + "," + note + ");"
    }

    // console.log(sql)


    let formData = new FormData();
    formData.append('query', encodeURIComponent(sql));
    axios({
        method: 'post',
        url: this.$url+sessionStorage.getItem('url_query_form'),
        data: {query:encodeURIComponent(sql)},
    })
    .then(res => {
        this.isLoading = false;
    })

});



// STEP THREE -----------------
    // SET GROUP PUBLIC !!!! !!!! !!!!


},

check_access:function() {
// CHECK IF CAN ADD NEW SCHED
    if (sessionStorage.getItem('user_level') === 'ADMIN') 
    {return false} else {return true}
},


check_mobile() {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return true} else {return false} 
},
return_column_width(colD, colM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return colM} else {return colD} 
},
return_text_size(sizeD, sizeM) {
if (sessionStorage.getItem('isMobile') == 'true') 
  {return sizeM} else {return sizeD} 
},


clear_group:function() {
    this.show_detail_index = -1
    this.selected_group=''
    this.get_schedule()
},
clear_sched:function() {
    this.show_detail_index = -1
    this.selected_schedule=''
    this.get_schedule()
},
clear_prof:function() {
    this.selected_prof=''
    this.get_schedule()
},

prof_change:function() {

    this.selected_group = '' 
    this.selected_schedule = ''
    this.show_detail_index = -1
   // var index = document.getElementById("select_prof").selectedIndex 
   // this.dt_calendar = moment(this.data_profs[index].dtS).format('YYYY-MM-DD')
    this.get_schedule()

},


date_debut_change:function() {
// RELOAD SCHED/GROUP CODES
 this.isLoading = true;

// GET GROUP CODES // GET SCHEDULE CODES 
 var sql =  "SELECT DISTINCT  MyMEQ_GROUP.group_CODE, MIN(MyMEQ_GROUP.group_datSTART) AS dtS, MAX(MyMEQ_GROUP.group_datEND) AS dtE,  COUNT(DISTINCT MyMEQ_COURSESTUDENT.student_ID) AS cntStud, COUNT(DISTINCT MyMEQ_GROUP.cour_ID) AS cntCour FROM  MyMEQ_GROUP INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_GROUP.group_ID = MyMEQ_COURSESTUDENT.group_ID WHERE group_datSTART >= '" + this.dt_calendar +  "' group by group_CODE "
sql +=  sessionStorage.getItem('sql_prof') + "  ORDER BY group_CODE"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { this.data_groups = res.data 



var sql =  "SELECT * FROM  myMEQ_SCHEDULE_GROUP WHERE schedGrp_minDate >= '" + this.dt_calendar +  "' "
sql +=  sessionStorage.getItem('sql_prof') + "  ORDER BY schedGrp_CODE"

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
.then(res => { this.data_sched = res.data 
    this.isLoading = false;
}) }) 


},





schedule_code_change:function() {

    var index = document.getElementById("select_schedule").selectedIndex
    if (index > -1) {
        this.selected_group = ''
        this.show_detail_index = index
        this.dt_calendar = moment(this.data_sched[index].schedGrp_minDate).add(-1, 'days').format('YYYY-MM-DD')
        this.selected_schedule = this.data_sched[index].schedGrp_CODE
        this.get_schedule()
    } else  {
        this.show_detail_index = -1

        this.detail_start = '';this.detail_end = '';this.detail_courses = '';this.detail_students = ''

        this.dt_calendar = moment().add(-7, 'days').format('YYYY-MM-DD')
        this.selected_group = ''
        this.get_schedule()
    }

},

group_code_change:function() {

    var index = document.getElementById("select_group").selectedIndex
    if (index > -1) {
        this.selected_schedule = ''
        this.show_detail_index = index

        this.detail_start = this.data_groups[index].dtS
        this.detail_end = this.data_groups[index].dtE
        this.detail_courses = this.data_groups[index].cntCour
        this.detail_students = this.data_groups[index].cntStud

        this.dt_calendar = moment(this.data_groups[index].dtS).add(-1, 'days').format('YYYY-MM-DD')
        this.selected_group = this.data_groups[index].group_CODE
        this.get_schedule()
    } else  {
        this.show_detail_index = -1

        this.detail_start = '';this.detail_end = '';this.detail_courses = '';this.detail_students = ''



        this.dt_calendar = moment().add(-7, 'days').format('YYYY-MM-DD')
        this.selected_group = ''
        this.get_schedule()
    } 
},


//if (sessionStorage.getItem('user_level') == 'PROF') { sqlProf = ' AND myMEQ_SCHEDULE_MAIN.staff_ID = ' + sessionStorage.getItem('user_ID') }

get_schedule:function() {

this.isLoading=true;
this.data_events = [];

// CHECK IF PROF ------------------------------ LOGGED IN !!!! !!!! !!!! ????
var sqlProf = ''
if (this.selected_prof != '') { sqlProf = " AND myMEQ_SCHEDULE_MAIN.staff_ID = " + sessionStorage.getItem('user_ID') + " "}
 
var sqlGroup = ''
if (this.selected_group != '') { sqlGroup = " AND MyMEQ_GROUP.group_CODE = '" + this.selected_group + "' "}

var sqlCampus = ''
if (this.selected_campus != '') { sqlCampus = " AND schedRoom_CAMPUS = '" + this.selected_campus + "' "}


// CHECK SCHEDULE CODE
if (this.selected_schedule != '') 
{    
    sqlGroup = " AND " 
    var i; var courses = this.data_sched[this.show_detail_index].schedGrp_IDs.split(",");
    for (i = 0; i < courses.length -1 ; i++) {
        sqlGroup += " (myMEQ_SCHEDULE_MAIN.group_ID = " + courses[i] + ") OR "
    }
    sqlGroup = sqlGroup.substring(0, sqlGroup.length - 4);
}
 


var query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS,  MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
,MyMEQ_COUR.cour_TITRE_F, group_CODE FROM myMEQ_SCHEDULE_MAIN LEFT OUTER JOIN MyMEQ_GROUP ON myMEQ_SCHEDULE_MAIN.group_ID = MyMEQ_GROUP.group_ID LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID 
LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID LEFT OUTER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID   
WHERE schedMain_date >= '` + this.dt_calendar + `' ` + sqlProf + sqlGroup + sqlCampus + ` ORDER BY schedMain_date, schedMain_AmPmSoir`

// console.log('** PROF SCHED ...')
// console.log(query)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 

//alert(res.data.length)

        var i;
        for (i = 0; i < res.data.length; i++) {

var desc = "<div class='columns is-gapless is-multiline'>"
desc += "<div class='column is-12 is-size-6 has-text-weight-bold'> " + res.data[i].cour_TITRE_F + " </div>"
desc += "<div class='column is-12'> " + res.data[i].prof + " </div>"
desc += "<div class='column is-9'> " + res.data[i].schedRoom_CAMPUS + " </div>"
desc += "<div class='column is-3 is-size-5 has-text-weight-bold has-text-centered' style='margin-top:-.5em;'> " + res.data[i].schedRoom_DESC  + "</div>"
desc += "<div>"

          this.data_events.push( 
            { 
              id:res.data[i].schedMain_ID,
              course:res.data[i].cour_TITRE_F,
              title: desc, //res.data[i].schedMain_AmPmSoir + " <br> " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF + " --" + res.data[i].schedMain_ID,
              details: 'GROUP : ' + res.data[i].group_CODE + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
              date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
              open: false,
              class:'my-event',
              color: res.data[i].schedMain_COLOUR,
              hour:res.data[i].schedMain_AmPmSoir
            })
        }  // END FOR



// CHECK SCHEDULE CODE ---- SUMMARY !!!!
if (this.selected_schedule != '') {
    var query = sqlGroup.replace("AND", "")
    query = query.replace(/myMEQ_SCHEDULE_MAIN/g,"MyMEQ_GROUP")
    query = "SELECT  min(group_datSTART) AS dtS, max(group_datEND) AS dtE, COUNT(DISTINCT MyMEQ_COURSESTUDENT.student_ID) AS cntStud, COUNT(DISTINCT MyMEQ_GROUP.cour_ID) AS cntCour FROM  MyMEQ_GROUP INNER JOIN  MyMEQ_COURSESTUDENT ON MyMEQ_GROUP.group_ID = MyMEQ_COURSESTUDENT.group_ID WHERE " + query
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.detail_start = res.data[0].dtS
    this.detail_end = res.data[0].dtE
    this.detail_courses = res.data[0].cntCour
    this.detail_students = res.data[0].cntStud
});

} // END CHECK SCHED ....



        this.isLoading=false;
        }); // END AXIOS SCHED DATA



},
// END GET SCHEDULE DATA !




change_view:function(bCal) {
    // SWITCH BETWEEN CALENDAR / SCHEDULE VIEW  
    this.view_calendar = bCal
    this.view_schedule = !bCal

},

return_date:function(dt) {
    return moment(dt).format("MMM DD YY")
},

sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},


return_column_size:function(dtIN) {
// IF WEEKEND COL = 1

var retStyle = 'column colBorder'

    if (isWeekend(new Date(dtIN))) {retStyle += " is-1 "} else {retStyle += " is-2 "} // ENDIF

// hLight monthchange
    var mo = getMonth(new Date(dtIN))
    if (mo % 2 === 0)  {
        retStyle += " has-background-light "
    } else {
        retStyle += " has-background-light "
    } // ENDIF

return retStyle

}, // END COLUMN SIZE

return_style_month_change:function(dtIN) {
// hLight monthchange
    var mo = getMonth(new Date(dtIN))
    if (mo % 2 === 0)  {
        return " has-background-link-light "
    } else {
        return " has-background-warning-light "
    } // ENDIF
},

return_style_sessann:function(sess) {
    if (sess == 'E') {return 'has-background-success'}
    else if (sess == 'H') {return 'has-background-info'}
    else if (sess == 'A') {return 'has-background-warning'}
},



}, // END METHODS


}
</script>